// libs
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import { IAddress } from 'src/interfaces/address'

// classes
import LocationPicker from 'src/components/location_picker/location_picker'
import { PlaceSuggestionType } from 'src/utils/places/autocomplete'

// helpers
import { formatAddress } from 'src/utils/location'

import './address_picker.scss'

const cls = CLASS_PREFIX + 'address-picker'

interface IProps {
  address?: IAddress;
  autoFocusSearchInput?: boolean;
  homeAddress?: IAddress;
  label?: string;
  onChange?: (address?: IAddress) => void;
  onLocateMe?: () => void;
  pickerResultsType?: PlaceSuggestionType;
  preFilledAddress?: IAddress;
  postValidation?: boolean;
  streetRequired?: boolean;
}

const AddressPicker = ({
  address,
  autoFocusSearchInput,
  pickerResultsType,
  homeAddress,
  label,
  onChange,
  onLocateMe,
  preFilledAddress,
  postValidation,
  streetRequired
}: IProps) => {
  const area = address?.locationShape.slug ?? homeAddress?.locationShape.slug

  return (
    <div className={cls}>
      <div className={cls + '__location-container'}>
        <LocationPicker
          autoFocusSearchInput={autoFocusSearchInput}
          clear={onChange}
          label={label}
          area={area}
          preFilledAddress={preFilledAddress}
          onChange={onChange}
          homeLocation={homeAddress}
          streetRequired={streetRequired !== undefined ? streetRequired : false}
          validateAddress={postValidation}
          type={pickerResultsType}
          defaultAddress={address && formatAddress(address)}
          onLocateMe={onLocateMe}
        />
      </div>
    </div>
  )
}

export default AddressPicker
